'use client';

import { useContext, useEffect, useMemo } from 'react';
import { useUnit } from 'effector-react';
import { SocketContext } from '@nx-frontend/shared/providers';
import { $currentWorkspace } from '@nx-frontend/shared/store/current-workspace';
import { getDuplicateFolderStateFx, updateDuplicateFolderStateEvent } from '@nx-frontend/shared/store/duplicate-folder';
import { upsertFileEvent } from '@nx-frontend/shared/store/feature-files';
import { $portalSettings } from '@nx-frontend/shared/store/portal';
import { addWorkspaceFileEvent } from '@nx-frontend/webnotes-client/shared/store';
import { AppSocketEventsListener } from './app-socket-events-listener';

export function AppSocketEvents() {
  const socket = useContext(SocketContext);

  const [addWorkspaceFile, upsertFile, updateDuplicateFolderState, getDuplicateFolderState] = useUnit([
    addWorkspaceFileEvent,
    upsertFileEvent,
    updateDuplicateFolderStateEvent,
    getDuplicateFolderStateFx,
  ]);
  const [portalSettings, currentWorkspace] = useUnit([$portalSettings, $currentWorkspace]);
  const workspaceId = currentWorkspace.globalId;

  const showPortalFiles = useMemo(() => {
    const { isCustomizerAccessDenied, isPortalAccessDenied } = portalSettings;
    return !isCustomizerAccessDenied || !isPortalAccessDenied;
  }, [portalSettings]);

  useEffect(() => {
    if (socket) {
      const listener = AppSocketEventsListener.getInstance();
      listener.init({
        workspaceId,
        showPortalFiles,
        addWorkspaceFile,
        upsertFile,
        updateDuplicateFolderState,
        getDuplicateFolderState,
        listenSocketEvent: (eventName, listener) => {
          socket.on(eventName, listener);
        },
      });
    }
  }, [
    socket,
    workspaceId,
    showPortalFiles,
    addWorkspaceFile,
    upsertFile,
    updateDuplicateFolderState,
    getDuplicateFolderState,
  ]);

  return null;
}
